/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Default Profile Icon component.
 */
export const DefaultAvatarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.87 10.7584C14.0861 10.7584 15.8826 9.02162 15.8826 6.8792C15.8826 4.73678 14.0861 3 11.87 3C9.65393 3 7.85742 4.73678 7.85742 6.8792C7.85742 9.02162 9.65393 10.7584 11.87 10.7584Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M3 17.1733C3 14.9642 4.79086 13.1733 7 13.1733H16.0008C18.2099 13.1733 20.0008 14.9642 20.0008 17.1733V20.4998C20.0008 20.7759 19.7769 20.9998 19.5008 20.9998H3.5C3.22386 20.9998 3 20.7759 3 20.4998V17.1733Z' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default DefaultAvatarIcon;
